export class RecargaCredito {
    _id: string;
    empresa_id: string;
    fechaRecarga: any;
    tipo: string;
    valor: number;
    estado: boolean;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/recargaCredito/recargaCredito.ts